import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Icon from 'components/icon/icon'

import SingleTaskPortal from 'sections/projects/project/project-tasks/single-task/single-task-portal'

import {
	getApplicableUsers,
} from 'utils'

export default class DashboardCalendarEventGroup extends Component {
	state = {
		isExpanded: false,
		contentsHeight: 70,
		currentlyOpenTaskId: null
	}

	componentDidMount = _ => {
		this.setContentsHeight()
	}

	componentDidUpdate = prevProps => {
		if (this.props.items && prevProps.items && this.props.items.length != prevProps.items.length) {
			this.setContentsHeight()
		}
	}

	toggleShowMore = _ => {
		this.setState({
			isExpanded: !this.state.isExpanded
		}, _ => {
			this.setContentsHeight()
		})
	}

	setContentsHeight = _ => {
		window.requestAnimationFrame(_ => {
			if (this.listRef) {
				this.setState({
					contentsHeight: (this.listRef.getBoundingClientRect().height + 15) // the extra 15 is so shadows on white don't get cut off
				})
			}
		})
	}

	openEvent = event => {
		this.props.openModal('view', 'event', event)
	}

	getItemSubtitle = item => {
		const {
			allMilestones,
			allProjects,
			type
		} = this.props

		switch (type) {
			case 'tasks':
			case 'tasksContinuing':
			case 'tasksStarting':
				const milestone = allMilestones[item.milestone_id]
				let project = null

				if (milestone) {
					project = allProjects[milestone.project_id]
				}

				return `${item.isRecurred ? 'Recurred • ' : ''}From ${milestone && milestone.name} ${project ? '• ' + project.name : null}`
			case 'events':
				switch (item.copy) {
					case '<p></p>':
					case '<p><br></p>':
						return null
				}

				return item.copy
		}
	}

	editEvent = event => {
		this.props.openModal('edit', 'event', event)
	}

	deleteEvent = event => {
		this.props.openModal('delete', 'event', event)
	}

	render() {
		const {
			type,
			items,
			handleSelect,
			match,
			allMilestones,
			allProjects,
			allUsers,
			allTeams,
			accountData,
			userData
		} = this.props

		const {
			isExpanded,
			contentsHeight,
			currentlyOpenTaskId
		} = this.state

		if (!items || !items.length) {
			return null
		}

		let title = ''

		switch (type) {
			case 'tasks':
				title = 'Tasks due'
				break
			case 'tasksContinuing':
				title = `Tasks continuing`
				break
			case 'tasksStarting':
				title = 'Tasks starting'
				break
			case 'events':
				title = 'Events'
				break
		}

		let itemsToLoop = [
			...items
		]

		let hasShowMore = false

		if (itemsToLoop.length > 3) {
			if (!isExpanded) {
				itemsToLoop.length = 3
			}

			hasShowMore = true
		}

		let rootProjectsUrls = `/${match.path.split('/')[1]}/projects/`

		return (
			<div className={type}>
				<h3>
					{title}
				</h3>
				<div style={{
					height: contentsHeight + 'px'
				}}>
					<ul
						ref={ref => this.listRef = ref}
						className="event-group-list"
					>
						{itemsToLoop.map(item => {
							const subtitle = this.getItemSubtitle(item)

							if (type === 'tasks' || type === 'tasksContinuing' || type === 'tasksStarting') {
								let url = rootProjectsUrls

								const milestone = allMilestones[item.milestone_id]
								const project = allProjects[milestone.project_id]

								const applicableUsers = getApplicableUsers(accountData, allUsers, project, allTeams)

								if (project && project.slug) {
									url += `${project.slug}/tasks/${item.id}`
								} else {
									url = null
								}

								if (!url) {
									return null
								}

								return (
									<li
										key={item.id}
									>
										<a
											onClick={e => {
												e.preventDefault()
												this.setState({
													currentlyOpenTaskId: item.id
												})
											}}
										>
											<h4>
												{item.name ? item.name : item.title}
											</h4>
											{subtitle &&
												<span>
													{subtitle}
												</span>
											}
										</a>
										{currentlyOpenTaskId === item.id ?
											<SingleTaskPortal
												project={project}
												applicableUsers={applicableUsers}
												taskId={item.id}
												close={() => {
													this.setState({
														currentlyOpenTaskId: null
													})
												}}
											/>
											: null}
									</li>
								)
							} else {
								return (
									<li
										key={item.id}
										onClick={_ => { this.openEvent(item) }}
									>
										<a href='javascript:void(0)'>
											<h4>
												{item.title}
												{item.user_id === userData.id ?
													<div
														className="controls"
														onClick={e => e.stopPropagation()}
													>
														<button onClick={_ => this.editEvent(item)}>
															<Icon name="fe-edit-2" />
														</button>
														<button onClick={_ => this.deleteEvent(item)}>
															<Icon name="fe-trash-2" />
														</button>
													</div>
													: null}
											</h4>
											{subtitle &&
												<span dangerouslySetInnerHTML={{ __html: subtitle }} />
											}
										</a>
									</li>
								)
							}
						})}
					</ul>
				</div>
				{hasShowMore &&
					<button
						className="show-more"
						onClick={this.toggleShowMore}
					>
						{isExpanded ? 'Show less...' : `Show ${items.length - itemsToLoop.length} more...`}
					</button>
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/sections/dashboard/dashboard-calendar-eventgroup.jsx